{
  "version": 1,
  "asset_id": "23410539-d19a-4746-bcf2-f293138ed1e3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/23410539-d19a-4746-bcf2-f293138ed1e3/hiatal-type-3-sleeve-es-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/23410539-d19a-4746-bcf2-f293138ed1e3/hiatal-type-3-sleeve-es-800.jpg",
  "original_filename": "hiatal-type-3-sleeve-es-800.jpg",
  "size": 135623,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T23:11:05Z"
}
